module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"Actualizar contenido","touDialogConfirmLabel":"Iniciar sesión y aceptar las condiciones","touDialogTitle":"Condiciones de uso de Adobe Experience Cloud","touTextLine1":"Se han actualizado las condiciones de uso de Adobe Experience Cloud.","touTextLine2a":"Inicie sesión en","touTextLine2b":"y acepte las condiciones actualizadas antes de continuar.","touTextLine3":"Tras aceptar las condiciones, haga clic en Actualizar contenido."}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/es_es.json
// module id = 915
// module chunks = 0